import { render, staticRenderFns } from "./TiltakListItemCounty.vue?vue&type=template&id=0b7b4ee4"
import script from "./TiltakListItemCounty.vue?vue&type=script&lang=js"
export * from "./TiltakListItemCounty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports